(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function PMCollection(root) {
      this.root = root;
      this.sectionId = root.getAttribute('data-section-id');
      this.controller = null;
      this.debounce = null;
      this.bind();
      this.applyDensity();
      this.reveal(root.querySelectorAll('[data-pmc-card]'));
      this.syncPrice();
      this.observeToolbar();
    }

    PMCollection.prototype.$ = function (sel) { return this.root.querySelector(sel); };

    /* ---------- Fetch + render ---------- */
    PMCollection.prototype.load = function (url, opts) {
      opts = opts || {};
      var self = this;
      var target = new URL(url, window.location.origin);
      target.searchParams.delete('section_id');
      var fetchUrl = new URL(target.toString());
      fetchUrl.searchParams.set('section_id', this.sectionId);

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.root.classList.add('is-loading');

      return fetch(fetchUrl.toString(), { signal: this.controller.signal, credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-pmc]');
          if (!fresh) { window.location.href = target.toString(); return; }
          if (opts.append) {
            self.appendFrom(fresh);
          } else {
            self.replaceFrom(fresh);
            if (opts.push !== false) window.history.pushState({ pmc: true }, '', target.toString());
          }
        })
        .catch(function (err) { if (err.name !== 'AbortError') window.location.href = target.toString(); })
        .finally(function () { self.root.classList.remove('is-loading'); });
    };

    PMCollection.prototype.swap = function (fresh, sel) {
      var a = this.$(sel), b = fresh.querySelector(sel);
      if (a && b) { a.innerHTML = b.innerHTML; return { a: a, b: b }; }
      return null;
    };

    PMCollection.prototype.replaceFrom = function (fresh) {
      var self = this;
      var grid = this.swap(fresh, '[data-pmc-grid]');
      this.swap(fresh, '[data-pmc-count]');
      this.swap(fresh, '[data-pmc-more-wrap]');
      this.swap(fresh, '[data-pmc-sort-menu]');
      this.swap(fresh, '[data-pmc-sort-label]');

      var chips = this.swap(fresh, '[data-pmc-chips]');
      if (chips) chips.a.hidden = chips.b.hidden;

      var badge = this.swap(fresh, '[data-pmc-filter-badge]');
      if (badge) badge.a.hidden = badge.b.hidden;

      var results = this.swap(fresh, '[data-pmc-results]');
      var applyBtn = this.$('.pmc-sheet__apply'), freshApply = fresh.querySelector('.pmc-sheet__apply');
      if (applyBtn && freshApply) applyBtn.innerHTML = freshApply.innerHTML;

      /* Empty state */
      var oldEmpty = this.$('[data-pmc-empty]'), newEmpty = fresh.querySelector('[data-pmc-empty]');
      if (oldEmpty) oldEmpty.remove();
      if (newEmpty) this.$('[data-pmc-grid]').insertAdjacentElement('afterend', newEmpty);

      /* Filter options: keep open sections and scroll position */
      var body = this.$('[data-pmc-sheet-body]'), freshBody = fresh.querySelector('[data-pmc-sheet-body]');
      if (body && freshBody) {
        var open = {};
        body.querySelectorAll('details[data-pmc-facet]').forEach(function (d) { open[d.getAttribute('data-pmc-facet')] = d.open; });
        var scroll = body.scrollTop;
        var focusedName = document.activeElement && body.contains(document.activeElement) ? document.activeElement.name : null;
        var keepPrice = this.fromPrice ? body.querySelector('[data-pmc-price]') : null;
        body.innerHTML = freshBody.innerHTML;
        if (keepPrice) {
          var newPrice = body.querySelector('[data-pmc-price]');
          if (newPrice) newPrice.replaceWith(keepPrice);
        }
        this.fromPrice = false;
        body.querySelectorAll('details[data-pmc-facet]').forEach(function (d) {
          var k = d.getAttribute('data-pmc-facet');
          if (k in open) d.open = open[k];
        });
        body.scrollTop = scroll;
        if (focusedName) { var f = body.querySelector('[name="' + focusedName + '"]'); if (f && f.type === 'number') f.focus(); }
        this.syncPrice();
      }

      var sortInput = this.$('[data-pmc-sort-input]'), freshSort = fresh.querySelector('[data-pmc-sort-input]');
      if (sortInput && freshSort) sortInput.value = freshSort.value;

      var search = this.$('[data-pmc-search]');
      if (search && search.value) this.search(search.value);
      if (grid) this.reveal(grid.a.querySelectorAll('[data-pmc-card]'));
    };

    PMCollection.prototype.appendFrom = function (fresh) {
      var grid = this.$('[data-pmc-grid]'), freshGrid = fresh.querySelector('[data-pmc-grid]');
      if (grid && freshGrid) {
        var cards = Array.prototype.slice.call(freshGrid.children);
        cards.forEach(function (c) { grid.appendChild(c); });
        this.reveal(cards);
      }
      this.swap(fresh, '[data-pmc-more-wrap]');
      var search = this.$('[data-pmc-search]');
      if (search && search.value) this.search(search.value);
    };

    /* ---------- Filters ---------- */
    PMCollection.prototype.formUrl = function () {
      var form = this.$('[data-pmc-form]');
      var params = new URLSearchParams();
      if (form) {
        var data = new FormData(form);
        var price = this.$('[data-pmc-price]');
        var max = price ? parseFloat(price.getAttribute('data-max')) : null;
        data.forEach(function (value, key) {
          if (value === '' || value == null) return;
          if (key.indexOf('price.gte') > -1 && parseFloat(value) <= 0) return;
          if (key.indexOf('price.lte') > -1 && max !== null && parseFloat(value) >= max) return;
          params.append(key, value);
        });
      } else {
        var cur = new URLSearchParams(window.location.search);
        if (cur.get('sort_by')) params.set('sort_by', cur.get('sort_by'));
      }
      var base = this.root.getAttribute('data-collection-url') || window.location.pathname;
      var qs = params.toString();
      return base + (qs ? '?' + qs : '');
    };

    PMCollection.prototype.onFormChange = function (delay) {
      var self = this;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(function () { self.load(self.formUrl()); }, delay == null ? 250 : delay);
    };

    PMCollection.prototype.syncPrice = function () {
      var wrap = this.$('[data-pmc-price]'); if (!wrap) return;
      var max = parseFloat(wrap.getAttribute('data-max')) || 0;
      var rMin = wrap.querySelector('[data-pmc-range="min"]'), rMax = wrap.querySelector('[data-pmc-range="max"]');
      var fill = wrap.querySelector('[data-pmc-price-fill]');
      if (!rMin || !rMax || !fill || !max) return;
      var a = parseFloat(rMin.value), b = parseFloat(rMax.value);
      /* Thumbs are 26px wide, so the usable track is 100% - 26px */
      fill.style.left = 'calc(' + (a / max) + ' * (100% - 26px) + 13px)';
      fill.style.right = 'calc(' + (1 - b / max) + ' * (100% - 26px) + 13px)';
      rMin.classList.toggle('is-top', a > max * 0.9);
      var display = wrap.querySelector('[data-pmc-price-display]');
      if (display) {
        var sym = wrap.getAttribute('data-currency') || '';
        var fmt = function (n) { return sym + Number(n).toLocaleString('en-IN'); };
        display.textContent = fmt(a) + ' \u2013 ' + fmt(b);
      }
    };

    /* ---------- Sheet ---------- */
    PMCollection.prototype.openSheet = function () {
      var sheet = this.$('[data-pmc-sheet]'); if (!sheet) return;
      if (typeof sheet.showModal === 'function') sheet.showModal(); else sheet.setAttribute('open', '');
      document.documentElement.classList.add('pmc-lock');
    };

    PMCollection.prototype.closeSheet = function () {
      var sheet = this.$('[data-pmc-sheet]'); if (!sheet || !sheet.open) return;
      sheet.classList.add('is-closing');
      setTimeout(function () {
        sheet.classList.remove('is-closing');
        if (typeof sheet.close === 'function') sheet.close(); else sheet.removeAttribute('open');
        document.documentElement.classList.remove('pmc-lock');
      }, 320);
    };

    /* ---------- Search inside the collection ---------- */
    PMCollection.prototype.search = function (q) {
      q = (q || '').trim().toLowerCase();
      var shown = 0;
      this.root.querySelectorAll('[data-pmc-card]').forEach(function (card) {
        var match = !q || (card.getAttribute('data-title') || '').toLowerCase().indexOf(q) > -1;
        card.hidden = !match;
        if (match) shown++;
      });
      var nomatch = this.$('[data-pmc-nomatch]');
      if (nomatch) {
        nomatch.hidden = !(q && shown === 0);
        var link = nomatch.querySelector('[data-pmc-search-all]');
        if (link) link.href = link.href.split('?')[0] + '?q=' + encodeURIComponent(q);
      }
    };

    /* ---------- Density ---------- */
    PMCollection.prototype.applyDensity = function (value) {
      var v = value;
      if (!v) { try { v = localStorage.getItem('pmc-density'); } catch (e) {} }
      if (v !== 'comfy' && v !== 'compact') v = 'compact';
      this.root.setAttribute('data-density', v);
      this.root.querySelectorAll('[data-pmc-density]').forEach(function (b) {
        /* both the toolbar switch and the floating switch stay in sync */
        b.classList.toggle('is-active', b.getAttribute('data-pmc-density') === v);
        b.setAttribute('aria-pressed', b.getAttribute('data-pmc-density') === v ? 'true' : 'false');
      });
      if (value) { try { localStorage.setItem('pmc-density', v); } catch (e) {} }
    };

    /* ---------- Motion ---------- */
    PMCollection.prototype.reveal = function (cards) {
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!this.io) {
        this.io = new IntersectionObserver(function (entries, io) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -40px 0px' });
      }
      var io = this.io;
      Array.prototype.forEach.call(cards, function (card, i) {
        card.classList.remove('is-in');
        card.classList.add('is-reveal');
        card.style.setProperty('--pmc-d', (i % 8) * 0.05 + 's');
        io.observe(card);
      });
    };

    PMCollection.prototype.observeToolbar = function () {
      var s = this.$('[data-pmc-sentinel]'), root = this.root, bar = this.$('[data-pmc-toolbar]');
      if (!('IntersectionObserver' in window)) return;
      if (s) {
        new IntersectionObserver(function (entries) {
          root.classList.toggle('is-stuck', !entries[0].isIntersecting);
        }).observe(s);
      }
      if (bar) {
        /* Show the floating Grid/List switch once the toolbar has scrolled above the screen */
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          root.classList.toggle('show-float', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(bar);
      }
    };

    /* ---------- Events ---------- */
    PMCollection.prototype.bind = function () {
      var self = this, root = this.root;

      root.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-pmc-open-filters]')) { e.preventDefault(); self.openSheet(); return; }
        if (t.closest('[data-pmc-close]')) { e.preventDefault(); self.closeSheet(); return; }

        var sortToggle = t.closest('[data-pmc-sort-toggle]');
        var sortWrap = self.$('[data-pmc-sort]');
        if (sortToggle && sortWrap) {
          var open = !sortWrap.classList.contains('is-open');
          sortWrap.classList.toggle('is-open', open);
          sortToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          return;
        }
        var opt = t.closest('[data-pmc-sort-value]');
        if (opt) {
          var v = opt.getAttribute('data-pmc-sort-value');
          var input = self.$('[data-pmc-sort-input]');
          if (input) input.value = v;
          if (sortWrap) sortWrap.classList.remove('is-open');
          var label = self.$('[data-pmc-sort-label]');
          if (label) label.textContent = opt.textContent.trim();
          var url;
          if (input) { url = self.formUrl(); }
          else {
            var p = new URLSearchParams(window.location.search); p.set('sort_by', v); p.delete('page');
            url = window.location.pathname + '?' + p.toString();
          }
          self.load(url);
          return;
        }

        var dens = t.closest('[data-pmc-density]');
        if (dens) {
          /* Keep the product the shopper was looking at in view after switching */
          var anchor = null;
          if (root.classList.contains('show-float')) {
            var cards = root.querySelectorAll('[data-pmc-card]:not([hidden])');
            for (var i = 0; i < cards.length; i++) {
              if (cards[i].getBoundingClientRect().bottom > 80) { anchor = cards[i]; break; }
            }
          }
          self.applyDensity(dens.getAttribute('data-pmc-density'));
          if (anchor) {
            var top = anchor.getBoundingClientRect().top + window.pageYOffset - 70;
            try { window.scrollTo({ top: top, behavior: 'instant' }); } catch (err) { window.scrollTo(0, top); }
          }
          return;
        }

        var more = t.closest('[data-pmc-more]');
        if (more) { e.preventDefault(); more.classList.add('is-loading'); more.textContent = 'Loading…'; self.load(more.href, { append: true }); return; }

        var link = t.closest('[data-pmc-link]');
        if (link) { e.preventDefault(); self.load(link.href); return; }

        var sheet = self.$('[data-pmc-sheet]');
        if (sheet && t === sheet) self.closeSheet();
      });

      document.addEventListener('click', function (e) {
        var sortWrap = self.$('[data-pmc-sort]');
        if (sortWrap && sortWrap.classList.contains('is-open') && !sortWrap.contains(e.target)) sortWrap.classList.remove('is-open');
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          var sortWrap = self.$('[data-pmc-sort]');
          if (sortWrap) sortWrap.classList.remove('is-open');
        }
      });

      var sheet = this.$('[data-pmc-sheet]');
      if (sheet) {
        sheet.addEventListener('cancel', function (e) { e.preventDefault(); self.closeSheet(); });
        sheet.addEventListener('close', function () { document.documentElement.classList.remove('pmc-lock'); });
      }

      root.addEventListener('input', function (e) {
        var t = e.target;
        if (t.matches('[data-pmc-search]')) { self.search(t.value); return; }
        if (t.matches('[data-pmc-range]')) {
          var wrap = t.closest('[data-pmc-price]');
          var rMin = wrap.querySelector('[data-pmc-range="min"]'), rMax = wrap.querySelector('[data-pmc-range="max"]');
          if (parseFloat(rMin.value) > parseFloat(rMax.value)) {
            if (t === rMin) rMin.value = rMax.value; else rMax.value = rMin.value;
          }
          var max = wrap.getAttribute('data-max');
          wrap.querySelector('[data-pmc-price-input="min"]').value = rMin.value === '0' ? '' : rMin.value;
          wrap.querySelector('[data-pmc-price-input="max"]').value = rMax.value === max ? '' : rMax.value;
          self.syncPrice();
          return;
        }
        if (t.matches('[data-pmc-price-input]')) {
          self.fromPrice = true;
          var w = t.closest('[data-pmc-price]');
          var r = w.querySelector('[data-pmc-range="' + t.getAttribute('data-pmc-price-input') + '"]');
          if (r && t.value !== '') r.value = t.value;
          self.syncPrice();
          self.onFormChange(700);
        }
      });

      root.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.closest('[data-pmc-form]')) return;
        self.fromPrice = !!t.closest('[data-pmc-price]');
        if (t.matches('[data-pmc-price-input]')) { self.onFormChange(0); return; }
        self.onFormChange(t.matches('[data-pmc-range]') ? 0 : 150);
      });

      root.addEventListener('submit', function (e) {
        if (e.target.matches('[data-pmc-form]')) { e.preventDefault(); self.onFormChange(0); }
      });
    };

    function init(scope) {
      (scope || document).querySelectorAll('[data-pmc]').forEach(function (el) {
        if (el.__pmc) return;
        el.__pmc = new PMCollection(el);
      });
    }

    window.addEventListener('popstate', function () {
      document.querySelectorAll('[data-pmc]').forEach(function (el) {
        if (el.__pmc) el.__pmc.load(window.location.href, { push: false });
      });
    });

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents, format) {
      cents = parseInt(cents, 10) || 0;
      format = format || '{{amount}}';
      var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var type = m ? m[1] : 'amount';
      function f(n, d, t, s) {
        var p = (n / 100).toFixed(d).split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
        return p[1] && d ? p[0] + s + p[1] : p[0];
      }
      var v;
      if (type === 'amount_no_decimals') v = f(cents, 0, ',', '.');
      else if (type === 'amount_with_comma_separator') v = f(cents, 2, '.', ',');
      else if (type === 'amount_no_decimals_with_comma_separator') v = f(cents, 0, '.', ',');
      else if (type === 'amount_with_apostrophe_separator') v = f(cents, 2, "'", '.');
      else v = f(cents, 2, ',', '.');
      var el = document.createElement('div');
      el.innerHTML = format.replace(/\{\{\s*\w+\s*\}\}/, v);
      return el.textContent;
    }

    function P(root) {
      this.r = root;
      try { this.variants = JSON.parse(root.querySelector('[data-pmx-variants]').textContent); } catch (e) { this.variants = []; }
      try { this.cfg = JSON.parse(root.querySelector('[data-pmx-config]').textContent); } catch (e) { this.cfg = {}; }
      this.track = this.q('[data-pmx-track]');
      this.active = -1;
      this.gallery();
      this.options();
      this.buy();
      this.tabs();
      this.floating();
      this.preferred();
      this.update(false);
      this.wish();
      this.rating();
      var self = this;
      window.addEventListener('resize', function () { self.tabInd(); });
    }

    P.prototype.q = function (s) { return this.r.querySelector(s); };
    P.prototype.qa = function (s) { return Array.prototype.slice.call(this.r.querySelectorAll(s)); };

    /* ---------- Gallery ---------- */
    P.prototype.slides = function () {
      if (this.ordered) return this.ordered.slice();
      return this.qa('[data-pmx-slide]').filter(function (s) { return !s.hidden; });
    };

    P.prototype.mark = function (i) {
      var list = this.slides();
      if (!list.length) return;
      i = Math.max(0, Math.min(i, list.length - 1));
      var slide = list[i];
      if (slide === this.activeSlide) return;
      this.activeSlide = slide;
      var idx = slide.getAttribute('data-index');
      this.qa('[data-pmx-dots] span').forEach(function (d) { d.classList.toggle('is-on', d.getAttribute('data-index') === idx); });
      var thumbs = this.qa('[data-pmx-thumb]');
      thumbs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-index') === idx); });
      var on = this.q('[data-pmx-thumb].is-on'), box = this.q('[data-pmx-thumbs]');
      if (on && box) box.scrollTo({ left: on.offsetLeft - box.clientWidth / 2 + on.clientWidth / 2, behavior: 'smooth' });
      this.qa('video').forEach(function (v) {
        try { if (v.closest('[data-pmx-slide]') === slide) v.play(); else v.pause(); } catch (e) {}
      });
      var img = slide.querySelector('img');
      this.slideImg = img ? (img.currentSrc || img.src) : null;
    };

    P.prototype.go = function (slide, smooth) {
      if (!slide || !this.track) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      this.mark(this.slides().indexOf(slide));
    };

    P.prototype.gallery = function () {
      var self = this, track = this.track;
      if (!track) return;
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          self.mark(Math.round(track.scrollLeft / (track.clientWidth || 1)));
        });
      }, { passive: true });

      this.r.addEventListener('click', function (e) {
        var th = e.target.closest('[data-pmx-thumb]');
        if (th) {
          var s = self.slides().find(function (x) { return x.getAttribute('data-index') === th.getAttribute('data-index'); });
          self.go(s);
          return;
        }
        if (e.target.closest('[data-pmx-open]')) { self.openView(self.activeSlide && self.activeSlide.getAttribute('data-index')); return; }
        var sl = e.target.closest('[data-pmx-slide]');
        if (sl && !sl.classList.contains('pmx__slide--external_video')) { self.openView(sl.getAttribute('data-index')); return; }
        if (e.target.closest('[data-pmx-view-close]')) self.closeView();
      });

      var vt = this.q('[data-pmx-view-track]'), vtick = false;
      if (vt) vt.addEventListener('scroll', function () {
        if (vtick) return; vtick = true;
        requestAnimationFrame(function () { vtick = false; self.viewCount(); });
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        var v = self.q('[data-pmx-view]');
        if (!v || !v.open || !vt) return;
        if (e.key === 'ArrowRight') vt.scrollBy({ left: vt.clientWidth, behavior: 'smooth' });
        if (e.key === 'ArrowLeft') vt.scrollBy({ left: -vt.clientWidth, behavior: 'smooth' });
      });
      this.mark(0);
    };

    P.prototype.filter = function (value) {
      if (!value) return;
      var v = value.toLowerCase().trim();
      var slides = this.qa('[data-pmx-slide]');
      var exact = slides.some(function (s) { return s.getAttribute('data-alt') === v; });
      var any = exact || slides.some(function (s) { return (s.getAttribute('data-alt') || '').indexOf(v) > -1; });
      var thumbs = {}, dots = {};
      this.qa('[data-pmx-thumb]').forEach(function (t) { thumbs[t.getAttribute('data-index')] = t; });
      this.qa('[data-pmx-dots] span').forEach(function (d) { dots[d.getAttribute('data-index')] = d; });
      slides.forEach(function (s) {
        var a = s.getAttribute('data-alt') || '', idx = s.getAttribute('data-index');
        var show = !any || a === '' || (exact ? a === v : a.indexOf(v) > -1);
        var order = any && a === '' ? 2 : 1;
        s.hidden = !show; s.style.order = order;
        if (thumbs[idx]) { thumbs[idx].hidden = !show; thumbs[idx].style.order = order; }
        if (dots[idx]) { dots[idx].hidden = !show; dots[idx].style.order = order; }
      });
      this.ordered = slides.filter(function (s) { return !s.hidden; }).sort(function (a, b) {
        return (a.style.order - b.style.order) || (a.getAttribute('data-index') - b.getAttribute('data-index'));
      });
      this.activeSlide = null;
      if (this.track) this.track.scrollTo({ left: 0, behavior: 'auto' });
      this.mark(0);
    };

    P.prototype.openView = function (index) {
      var view = this.q('[data-pmx-view]'); if (!view) return;
      var vis = {};
      this.slides().forEach(function (s) { vis[s.getAttribute('data-index')] = true; });
      var slides = this.qa('.pmx-view__slide');
      slides.forEach(function (s) { s.hidden = !vis[s.getAttribute('data-index')]; });
      if (typeof view.showModal === 'function') view.showModal(); else view.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      view.addEventListener('close', function () { document.documentElement.style.overflow = ''; }, { once: true });
      var vt = this.q('[data-pmx-view-track]'), target = this.q('.pmx-view__slide[data-index="' + index + '"]');
      if (vt && target && !target.hidden) vt.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
      this.viewCount();
    };

    P.prototype.closeView = function () {
      var view = this.q('[data-pmx-view]'); if (!view) return;
      if (typeof view.close === 'function') view.close(); else view.removeAttribute('open');
      document.documentElement.style.overflow = '';
    };

    P.prototype.viewCount = function () {
      var vt = this.q('[data-pmx-view-track]'), c = this.q('[data-pmx-view-count]');
      if (!vt || !c) return;
      var n = this.qa('.pmx-view__slide').filter(function (s) { return !s.hidden; }).length;
      var i = Math.round(vt.scrollLeft / (vt.clientWidth || 1));
      c.textContent = n ? (Math.min(i, n - 1) + 1) + ' of ' + n : '';
    };

    /* ---------- Options ---------- */
    P.prototype.sel = function () {
      return this.qa('[data-pmx-opt]').map(function (fs) { var c = fs.querySelector('[data-pmx-val]:checked'); return c ? c.value : null; });
    };

    P.prototype.find = function (sel) {
      return this.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); }) || null;
    };

    P.prototype.options = function () {
      var self = this;
      this.r.addEventListener('change', function (e) {
        var input = e.target.closest('[data-pmx-val]');
        if (!input) return;
        var fs = input.closest('[data-pmx-opt]'), lab = fs.querySelector('[data-pmx-opt-val]');
        if (lab) self.swap(lab, input.value);
        var color = !!input.closest('.pmx__swatches');
        if (color) self.filter(input.value);
        self.update(true, color);
      });
    };

    P.prototype.preferred = function () {
      var inputs = this.qa('.pmx__swatches [data-pmx-val]');
      if (!this.cfg.fromUrl && inputs.length) {
        var prefs = (this.cfg.preferred || []).map(function (p) { return String(p).trim().toLowerCase(); }).filter(Boolean);
        for (var p = 0; p < prefs.length; p++) {
          var hit = inputs.find(function (i) { return i.value.toLowerCase() === prefs[p]; });
          if (hit) {
            hit.checked = true;
            var l = hit.closest('[data-pmx-opt]').querySelector('[data-pmx-opt-val]');
            if (l) l.textContent = hit.value;
            break;
          }
        }
      }
      var c = this.q('.pmx__swatches [data-pmx-val]:checked');
      if (c) this.filter(c.value);
    };

    P.prototype.swap = function (el, text) {
      if (!el || el.textContent === text) return;
      el.textContent = text;
      if (el.animate) el.animate([{ opacity: 0, transform: 'translateY(5px)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'cubic-bezier(0.2,0.9,0.2,1)' });
    };

    P.prototype.update = function (push, fromColor) {
      var self = this, sel = this.sel(), v = this.find(sel), fmt = this.cfg.money;
      this.v = v;

      this.qa('[data-pmx-opt]').forEach(function (fs, oi) {
        fs.querySelectorAll('[data-pmx-val]').forEach(function (inp) {
          var t = sel.slice(); t[oi] = inp.value;
          var ok = self.variants.some(function (x) { return x.available && x.options.every(function (o, i) { return t[i] == null || o === t[i]; }); });
          inp.closest('label').classList.toggle('is-off', !ok);
        });
      });

      var add = this.q('[data-pmx-add]'), label = this.q('[data-pmx-add-label]'), fb = this.q('[data-pmx-float-add]'), stock = this.q('[data-pmx-stock]');
      if (!v) {
        if (add) add.disabled = true;
        if (label) label.textContent = 'Unavailable';
        if (fb) { fb.disabled = true; fb.textContent = 'Unavailable'; }
        if (stock) { stock.className = 'pmx__status-row is-out'; stock.innerHTML = '<span class="pmx__dot"></span><span>This combination isn’t available</span>'; }
        return;
      }

      var idInput = this.q('[data-pmx-id]'); if (idInput) idInput.value = v.id;
      var price = money(v.price, fmt);
      this.swap(this.q('[data-pmx-price]'), price);
      var ap = this.q('[data-pmx-add-price]'); if (ap) ap.textContent = price;

      var was = this.q('[data-pmx-compare]'), off = this.q('[data-pmx-save]');
      if (v.compare > v.price) {
        if (was) { was.hidden = false; was.textContent = money(v.compare, fmt); }
        if (off) { off.hidden = false; off.textContent = Math.round((v.compare - v.price) * 100 / v.compare) + '% off'; }
      } else {
        if (was) was.hidden = true;
        if (off) off.hidden = true;
      }

      if (add) add.disabled = !v.available;
      if (label) label.textContent = v.available ? 'Add to Cart' : 'Sold out';
      if (fb) { fb.disabled = !v.available; fb.textContent = v.available ? 'Add to Cart' : 'Sold out'; }

      if (stock) {
        var low = parseInt(this.cfg.low, 10) || 0;
        if (!v.available) {
          stock.className = 'pmx__status-row is-out';
          stock.innerHTML = '<span class="pmx__dot"></span><span><b>Sold out</b> <span class="pmx__muted">· Back soon</span></span>';
        } else if (v.qty != null && low > 0 && v.qty <= low) {
          stock.className = 'pmx__status-row is-low';
          stock.innerHTML = '<span class="pmx__dot"></span><span><b>Only ' + v.qty + ' left</b> <span class="pmx__muted">· Selling fast</span></span>';
        } else {
          stock.className = 'pmx__status-row is-in';
          stock.innerHTML = '<span class="pmx__dot"></span><span><b>In stock</b> <span class="pmx__muted">· Ready to ship</span></span>';
        }
      }

      if (!fromColor && v.media) {
        var slide = this.slides().find(function (s) { return s.getAttribute('data-media-id') == v.media; });
        if (slide) this.go(slide);
      }

      var meta = this.q('[data-pmx-float-meta]');
      if (meta) meta.textContent = (this.cfg.single ? '' : v.title + ' · ') + price;
      var fimg = this.q('[data-pmx-float-img]');
      var src = v.image || this.slideImg;
      if (fimg && src) { fimg.src = src; fimg.hidden = false; }

      if (push) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    /* ---------- Buy ---------- */
    P.prototype.toast = function (msg) {
      var t = document.querySelector('.pmx-toast');
      if (!t) { t = document.createElement('div'); t.className = 'pmx-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
      t.textContent = msg;
      t.classList.add('is-on');
      clearTimeout(this.tt);
      this.tt = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
    };

    P.prototype.buy = function () {
      var self = this, form = this.q('form.pmx__form') || this.q('form[action*="/cart/add"]');
      this.form = form;
      if (!form) return;
      this.r.addEventListener('click', function (e) {
        var q = e.target.closest('[data-pmx-qty]');
        if (q) {
          var inp = self.q('[data-pmx-qty-input]');
          var n = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.getAttribute('data-pmx-qty'), 10));
          if (self.v && self.v.qty != null && self.v.qty > 0 && n > self.v.qty) { n = self.v.qty; self.toast('Only ' + self.v.qty + ' available'); }
          inp.value = n;
          return;
        }
        if (e.target.closest('[data-pmx-share]')) { self.share(); return; }
        if (e.target.closest('[data-pmx-float-add]')) { self.add(e.target.closest('[data-pmx-float-add]')); return; }
        if (e.target.closest('[data-pmx-wish]')) self.toggleWish();
      });
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.closest && e.submitter.closest('.shopify-payment-button')) return;
        e.preventDefault();
        self.add();
      });
    };

    P.prototype.add = function (floatBtn) {
      var self = this, btn = this.q('[data-pmx-add]'), err = this.q('[data-pmx-err]');
      if (!this.form || !btn || btn.disabled || btn.classList.contains('is-load')) return;
      if (err) err.hidden = true;
      btn.classList.add('is-load');
      if (floatBtn) floatBtn.textContent = 'Adding…';
      fetch(this.r.getAttribute('data-cart-add-url'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(this.form)
      })
        .then(function (res) { return res.json().then(function (d) { if (!res.ok || d.status) throw d; return d; }); })
        .then(function () { return fetch(self.r.getAttribute('data-cart-js-url'), { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          btn.classList.remove('is-load');
          btn.classList.add('is-ok');
          if (floatBtn) { floatBtn.classList.add('is-ok'); floatBtn.textContent = 'Added ✓'; }
          setTimeout(function () {
            btn.classList.remove('is-ok');
            if (floatBtn) { floatBtn.classList.remove('is-ok'); floatBtn.textContent = 'Add to Cart'; }
          }, 1800);
          self.sync(cart);
        })
        .catch(function (d) {
          btn.classList.remove('is-load');
          if (floatBtn) floatBtn.textContent = 'Add to Cart';
          var msg = (d && (d.description || d.message)) || 'Couldn’t add to your bag. Please try again.';
          if (err) { err.textContent = msg; err.hidden = false; }
          self.toast(msg);
        });
    };

    P.prototype.rating = function () {
      var el = this.q('[data-pmx-rating]');
      if (!el) return;
      var self = this;
      el.addEventListener('click', function (e) {
        var target = document.querySelector('[data-pmr]:not([hidden])') || document.querySelector('.jdgm-review-widget, #judgeme_product_reviews');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      if (el.getAttribute('data-source') !== 'sheet') return;
      function apply(d) {
        if (!d || !d.count) { el.hidden = true; return; }
        var avg = Math.max(0, Math.min(5, d.avg));
        self.q('[data-pmx-rstars]').style.setProperty('--r', (avg / 5 * 100) + '%');
        self.q('[data-pmx-rnum]').textContent = avg.toFixed(1);
        self.q('[data-pmx-rcount]').textContent = d.count + (d.count === 1 ? ' review' : ' reviews');
        if (d.star) el.style.setProperty('--x-star', d.star);
        el.hidden = false;
      }
      if (window.__pmrSummary) apply(window.__pmrSummary);
      document.addEventListener('pmr:summary', function (e) { apply(e.detail); });
    };

    P.prototype.wishList = function () {
      try { return JSON.parse(localStorage.getItem('pmx-wishlist') || '[]'); } catch (e) { return []; }
    };

    P.prototype.wish = function () {
      var btn = this.q('[data-pmx-wish]'); if (!btn) return;
      var on = this.wishList().indexOf(btn.getAttribute('data-handle')) > -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    };

    P.prototype.toggleWish = function () {
      var btn = this.q('[data-pmx-wish]'); if (!btn) return;
      var h = btn.getAttribute('data-handle'), list = this.wishList(), i = list.indexOf(h), on = i === -1;
      if (on) list.push(h); else list.splice(i, 1);
      try { localStorage.setItem('pmx-wishlist', JSON.stringify(list)); } catch (e) {}
      this.wish();
      btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop');
      if (navigator.vibrate) { try { navigator.vibrate(10); } catch (e) {} }
      this.toast(on ? 'Saved to your wishlist' : 'Removed from your wishlist');
      document.dispatchEvent(new CustomEvent('pmx:wishlist', { detail: { handle: h, saved: on, list: list } }));
    };

    P.prototype.sync = function (cart) {
      var count = cart && cart.item_count;
      var ev = new Event('shopify:cart:lines-update', { bubbles: true });
      ev.action = 'add';
      ev.context = 'product';
      ev.promise = Promise.resolve({ cart: { totalQuantity: count }, detail: { itemCount: count } });
      document.dispatchEvent(ev);
      document.querySelectorAll('cart-icon').forEach(function (i) { if (typeof i.renderCartBubble === 'function') i.renderCartBubble(count, true); });
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') setTimeout(function () { if (!drawer.isOpen) drawer.open(); }, 300);
      else this.toast('Added to your bag');
    };

    P.prototype.share = function () {
      var data = { title: document.title, url: window.location.href }, self = this;
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () { self.toast('Link copied'); });
    };

    /* ---------- Tabs ---------- */
    P.prototype.tabInd = function () {
      var on = this.q('.pmx__tab.is-on'), ind = this.q('.pmx__tab-ind');
      if (!on || !ind) return;
      ind.style.width = on.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + on.offsetLeft + 'px)';
    };

    P.prototype.tabs = function () {
      var self = this;
      this.r.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-pmx-tab]');
        if (!tab) return;
        var id = tab.getAttribute('data-pmx-tab');
        self.qa('[data-pmx-tab]').forEach(function (t) { var on = t === tab; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        self.qa('[data-pmx-pane]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-pmx-pane') === id); });
        self.tabInd();
      });
      this.tabInd();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.tabInd(); });
    };

    /* ---------- Floating bar ---------- */
    P.prototype.floating = function () {
      var r = this.r, add = this.q('[data-pmx-add]'), bar = this.q('[data-pmx-float]');
      if (!add || !bar) return;
      var ticking = false;
      function apply() {
        ticking = false;
        var show = add.getBoundingClientRect().bottom < 0;
        if (r.classList.contains('show-float') === show) return;
        r.classList.toggle('show-float', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = bar.querySelector('[data-pmx-float-add]'); if (b) b.tabIndex = show ? 0 : -1;
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      apply();
    };

    function init(scope) {
      (scope || document).querySelectorAll('[data-pmx]').forEach(function (el) { if (!el.__pmx) el.__pmx = new P(el); });
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";

  function HRV(mountEl, S) {


  /* ---------- Settings (with safe defaults) ---------- */
  var COLS = S.COLUMNS || { name: 1, rating: 2, title: 3, body: 4, date: 5, verified: 6, images: [7, 8, 9, 10], videos: [11, 12, 13, 14] };
  var PER_PAGE = parseInt(S.REVIEWS_PER_PAGE, 10) || 6;
  var CLAMP = parseInt(S.TEXT_CLAMP_CHARS, 10) || 220;
  var STORE_KEY = "hrv_helpful_" + String(S.CSV_URL || "").split("?")[0].split("/").pop();

  /* ---------- State ---------- */
  var reviews = [];
  var allMedia = [];
  var state = { star: null, media: false, verified: false, query: "", sort: S.DEFAULT_SORT || "recent", visible: PER_PAGE, expanded: {} };
  var helpful = loadHelpful();
  var mount, lb, lbItems = [], lbIndex = 0, searchTimer;

  /* ---------- Icons ---------- */
  var STAR_PATH = '<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>';
  var ICON_STAR = '<svg viewBox="0 0 24 24" aria-hidden="true">' + STAR_PATH + '</svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_BADGE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 1l2.6 2.1 3.3-.4 1.2 3.1 3.1 1.2-.4 3.3L23 12l-2.1 2.6.4 3.3-3.1 1.2-1.2 3.1-3.3-.4L12 23l-2.6-2.1-3.3.4-1.2-3.1-3.1-1.2.4-3.3L1 12l2.1-2.6-.4-3.3 3.1-1.2 1.2-3.1 3.3.4z"/><path d="M7.5 12.2l3 3 6-6.2" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_SHIELD = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>';
  var ICON_CAMERA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>';
  var ICON_THUMB = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>';
  var ICON_SEARCH = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>';
  var ICON_PLAY = '<span class="hrv-play"><i><svg viewBox="0 0 24 24"><path d="M6 4l15 8-15 8z"/></svg></i></span>';
  var ICON_PEN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>';
  var ICON_L = '<svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>';
  var AVATAR_COLORS = ["#1d1d1f", "#0071e3", "#248A3D", "#BF5AF2", "#FF9F0A", "#FF375F", "#5E5CE6", "#30B0C7", "#A2845E"];

  /* ---------- Helpers ---------- */
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function safeUrl(u) {
    u = String(u || "").trim();
    return /^(https?:)?\/\//i.test(u) ? u : "";
  }
  function cell(row, i) { return (row[i] == null ? "" : String(row[i])).trim(); }

  function starsHtml(value, size) {
    var pct = Math.max(0, Math.min(100, (value / 5) * 100));
    var five = ICON_STAR + ICON_STAR + ICON_STAR + ICON_STAR + ICON_STAR;
    return '<span class="hrv-stars" style="--s:' + size + 'px" role="img" aria-label="' + value + ' out of 5 stars">' +
      '<span class="hrv-stars-row hrv-stars-row--off">' + five + '</span>' +
      '<span class="hrv-stars-row hrv-stars-row--on" style="width:' + pct + '%">' + five + '</span></span>';
  }

  function avatarColor() {
    return S.AVATAR_BG || "#1d1d1f";
  }
  function initials(name) {
    var parts = name.replace(/[^\p{L}\p{N} ]/gu, "").trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return "?";
    return (parts[0].charAt(0) + (parts.length > 1 ? parts[parts.length - 1].charAt(0) : "")).toUpperCase();
  }

  // Handles "june-26", "June 26", "june/26", "June 2026" and normal dates
  function parseCustomDate(str) {
    if (!str) return 0;
    var parts = str.trim().split(/[- /,]+/);
    var months = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
    if (parts.length >= 2) {
      var m = months[parts[0].toLowerCase().substring(0, 3)];
      var y = parseInt(parts[parts.length - 1], 10);
      if (m !== undefined && !isNaN(y)) {
        if (y < 100) y += 2000;
        var d = parts.length >= 3 ? parseInt(parts[1], 10) : 1;
        return new Date(y, m, isNaN(d) || d > 31 ? 1 : d).getTime();
      }
    }
    var t = Date.parse(str);
    return isNaN(t) ? 0 : t;
  }

  function parseCSV(text) {
    text = text.replace(/^\uFEFF/, "");
    var rows = [], row = [""], i = 0, inQ = false, prev = "";
    for (var k = 0; k < text.length; k++) {
      var ch = text[k];
      if (ch === '"') {
        if (!inQ && prev === '"') row[i] += '"';
        inQ = !inQ;
      } else if (ch === "," && !inQ) {
        row[++i] = ""; ch = "";
      } else if (ch === "\n" && !inQ) {
        if (prev === "\r") row[i] = row[i].slice(0, -1);
        rows.push(row); row = [""]; i = 0; ch = "";
      } else {
        row[i] += ch;
      }
      prev = ch;
    }
    if (row.length > 1 || row[0] !== "") {
      if (row[i].slice(-1) === "\r") row[i] = row[i].slice(0, -1);
      rows.push(row);
    }
    rows.shift(); // header
    return rows;
  }

  function loadHelpful() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || "{}") || {}; } catch (e) { return {}; }
  }
  function saveHelpful() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(helpful)); } catch (e) {}
  }

  /* ---------- Build data ---------- */
  function buildReviews(rows) {
    return rows
      .filter(function (r) { return r.length >= 5 && cell(r, COLS.name) !== ""; })
      .map(function (r, idx) {
        var dateStr = cell(r, COLS.date);
        var v = cell(r, COLS.verified).toLowerCase();
        var name = cell(r, COLS.name);
        var title = cell(r, COLS.title);
        var body = cell(r, COLS.body);
        var images = (COLS.images || []).map(function (c) { return safeUrl(cell(r, c)); }).filter(Boolean);
        var videos = (COLS.videos || []).map(function (c) { return safeUrl(cell(r, c)); }).filter(Boolean);
        return {
          id: "r" + idx + "_" + (name + title).length,
          name: name,
          rating: Math.max(1, Math.min(5, parseInt(cell(r, COLS.rating), 10) || 5)),
          title: title,
          body: body,
          dateStr: dateStr,
          timestamp: parseCustomDate(dateStr),
          verified: /yes|true|verified|^1$|^y$/.test(v),
          media: images.map(function (u) { return { type: "img", url: u }; })
            .concat(videos.map(function (u) { return { type: "video", url: u }; })),
          index: idx,
          search: (name + " " + title + " " + body).toLowerCase()
        };
      });
  }

  /* ---------- Render: static shell ---------- */
  function renderShell() {
    var n = reviews.length;
    var total = 0, counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }, verified = 0, recommend = 0;
    reviews.forEach(function (r) {
      total += r.rating; counts[r.rating]++;
      if (r.verified) verified++;
      if (r.rating >= 4) recommend++;
    });
    var avg = total / n;
    var avgStr = avg.toFixed(1);
    var recPct = Math.round((recommend / n) * 100);
    var verPct = Math.round((verified / n) * 100);

    allMedia = [];
    reviews.forEach(function (r) { r.media.forEach(function (m, mi) { allMedia.push({ type: m.type, url: m.url, review: r, mi: mi }); }); });

    var bars = [5, 4, 3, 2, 1].map(function (s) {
      var pct = n ? Math.round((counts[s] / n) * 100) : 0;
      return '<button type="button" class="hrv-bar" data-star="' + s + '"' + (counts[s] ? "" : " disabled") +
        ' aria-pressed="false" aria-label="Show ' + s + ' star reviews (' + counts[s] + ')">' +
        '<span class="hrv-bar-label">' + s + ICON_STAR + '</span>' +
        '<span class="hrv-bar-track"><span class="hrv-bar-fill" data-w="' + pct + '"></span></span>' +
        '<span class="hrv-bar-count"><span class="c">' + counts[s] + '</span><span class="p">' + pct + '%</span></span></button>';
    }).join("");

    var metrics =
      '<div class="hrv-metric"><div class="hrv-ring"><svg viewBox="0 0 52 52"><circle class="bg" cx="26" cy="26" r="22"/><circle class="fg" cx="26" cy="26" r="22" data-pct="' + recPct + '"/></svg><span>' + recPct + '%</span></div>' +
      '<div class="hrv-metric-text"><b>Would recommend</b><span>' + recommend + ' of ' + n + ' rated 4\u2605 or higher</span></div></div>';
    if (verified > 0) {
      metrics += '<div class="hrv-metric"><div class="hrv-metric-icon is-green">' + ICON_SHIELD + '</div>' +
        '<div class="hrv-metric-text"><b>' + verPct + '% Verified buyers</b><span>' + verified + ' confirmed purchases</span></div></div>';
    }
    if (allMedia.length > 0) {
      metrics += '<div class="hrv-metric"><div class="hrv-metric-icon">' + ICON_CAMERA + '</div>' +
        '<div class="hrv-metric-text"><b>' + allMedia.length + ' Customer ' + (allMedia.length === 1 ? "photo" : "photos & videos") + '</b><span>Shared by real buyers</span></div></div>';
    }

    var trust = (S.TRUST_POINTS || []).filter(Boolean).map(function (t) {
      return '<span class="hrv-trust-item">' + ICON_CHECK.replace("<svg", '<svg fill="none"') + esc(t) + '</span>';
    }).join("");

    var photos = "";
    if (S.SHOW_PHOTO_STRIP !== false && allMedia.length) {
      photos = '<div class="hrv-photos"><div class="hrv-photos-head"><h3 class="hrv-h3">Customer Photos & Videos</h3>' +
        '<span class="hrv-photos-count">' + allMedia.length + ' total</span></div><div class="hrv-photos-row">' +
        allMedia.map(function (m, i) { return thumbHtml(m, "all", i); }).join("") + '</div></div>';
    }

    var sortOpts = [["recent", "Most Recent"], ["relevance", "Most Relevant"], ["highest", "Highest Rated"], ["lowest", "Lowest Rated"], ["media", "With Photos First"]]
      .map(function (o) { return '<option value="' + o[0] + '"' + (state.sort === o[0] ? " selected" : "") + '>' + o[1] + '</option>'; }).join("");

    mount.innerHTML =
      '<div class="hrv-wrap">' +
        headHtml() +
        '<div class="hrv-panel">' +
          '<div class="hrv-score">' +
            '<div class="hrv-score-num"><span data-count="' + avgStr + '">' + avgStr + '</span><small> / 5</small></div>' +
            starsHtml(Math.round(avg * 10) / 10, 22) +
            '<div class="hrv-score-meta">Based on <b>' + n + '</b> ' + (n === 1 ? "review" : "reviews") + '</div>' +
          '</div>' +
          '<div class="hrv-bars">' + bars + '</div>' +
          '<div class="hrv-metrics">' + metrics + '</div>' +
        '</div>' +
        (trust ? '<div class="hrv-trust">' + trust + '</div>' : "") +
        photos +
        '<div class="hrv-toolbar">' +
          '<div class="hrv-chips" data-chips></div>' +
          '<div class="hrv-tools-right">' +
            (S.SHOW_SEARCH !== false ? '<label class="hrv-search">' + ICON_SEARCH + '<input type="search" placeholder="Search reviews" aria-label="Search reviews" data-search></label>' : "") +
            '<select class="hrv-select" data-sort aria-label="Sort reviews">' + sortOpts + '</select>' +
          '</div>' +
        '</div>' +
        '<div class="hrv-result" data-result></div>' +
        '<div class="hrv-grid" data-grid></div>' +
        '<div class="hrv-more" data-more></div>' +
      '</div>';

    var on = mount.querySelector(".hrv-score .hrv-stars-row--on");
    if (on) { on.setAttribute("data-w", on.style.width); on.style.width = "0%"; }
    dragScroll(mount.querySelector(".hrv-photos-row"));
    animateOnView();
  }

  function thumbHtml(m, scope, i) {
    var inner = m.type === "img"
      ? '<img src="' + esc(m.url) + '" alt="Photo from ' + esc(m.review.name) + '" loading="lazy">'
      : '<video src="' + esc(m.url) + '#t=0.1" muted playsinline preload="metadata"></video>' + ICON_PLAY;
    return '<button type="button" class="hrv-thumb" data-open="' + scope + '" data-i="' + i + '" aria-label="Open ' + (m.type === "img" ? "photo" : "video") + ' from ' + esc(m.review.name) + '">' + inner + '</button>';
  }

  function animateOnView() {
    var panel = mount.querySelector(".hrv-panel");
    var run = function () {
      mount.querySelectorAll(".hrv-bar-fill").forEach(function (el) { el.style.width = el.getAttribute("data-w") + "%"; });
      var sOn = mount.querySelector(".hrv-score .hrv-stars-row--on");
      if (sOn) { sOn.style.transition = "width 1.2s cubic-bezier(0.16, 1, 0.3, 1) .15s"; sOn.style.width = sOn.getAttribute("data-w"); }
      mount.querySelectorAll(".hrv-ring .fg").forEach(function (el) {
        var p = parseFloat(el.getAttribute("data-pct")) || 0;
        el.style.strokeDashoffset = String(138.2 * (1 - p / 100));
      });
      var num = mount.querySelector("[data-count]");
      if (num && window.requestAnimationFrame) {
        var target = parseFloat(num.getAttribute("data-count")), start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var t = Math.min(1, (ts - start) / 900), e = 1 - Math.pow(1 - t, 3);
          num.textContent = (target * e).toFixed(1);
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    };
    if (!("IntersectionObserver" in window) || !panel) return run();
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); run(); }
    }, { threshold: 0.25 });
    io.observe(panel);
  }

  /* ---------- Render: chips, grid, pager ---------- */
  function filtered() {
    var list = reviews.filter(function (r) {
      if (state.star !== null && r.rating !== state.star) return false;
      if (state.media && !r.media.length) return false;
      if (state.verified && !r.verified) return false;
      if (state.query && r.search.indexOf(state.query) === -1) return false;
      return true;
    });
    var byIndex = function (a, b) { return a.index - b.index; };
    var sorters = {
      recent: function (a, b) { return (b.timestamp - a.timestamp) || byIndex(a, b); },
      relevance: byIndex,
      highest: function (a, b) { return (b.rating - a.rating) || (b.timestamp - a.timestamp) || byIndex(a, b); },
      lowest: function (a, b) { return (a.rating - b.rating) || (b.timestamp - a.timestamp) || byIndex(a, b); },
      media: function (a, b) { return (b.media.length - a.media.length) || (b.timestamp - a.timestamp) || byIndex(a, b); }
    };
    return list.sort(sorters[state.sort] || sorters.recent);
  }

  function renderChips() {
    var withMedia = reviews.filter(function (r) { return r.media.length; }).length;
    var verified = reviews.filter(function (r) { return r.verified; }).length;
    var any = state.star !== null || state.media || state.verified || state.query;
    var html = '<button type="button" class="hrv-chip' + (any ? "" : " is-active") + '" data-chip="all">All reviews</button>';
    if (withMedia) html += '<button type="button" class="hrv-chip' + (state.media ? " is-active" : "") + '" data-chip="media" aria-pressed="' + state.media + '">With media (' + withMedia + ')</button>';
    if (verified) html += '<button type="button" class="hrv-chip' + (state.verified ? " is-active" : "") + '" data-chip="verified" aria-pressed="' + state.verified + '">Verified only</button>';
    if (state.star !== null) html += '<button type="button" class="hrv-chip is-active" data-chip="star">' + state.star + ' ' + ICON_STAR + ' only <span class="x">&times;</span></button>';
    mount.querySelector("[data-chips]").innerHTML = html;

    mount.querySelectorAll(".hrv-bar").forEach(function (b) {
      var on = parseInt(b.getAttribute("data-star"), 10) === state.star;
      b.classList.toggle("is-active", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function highlight(text) {
    var safe = esc(text);
    if (!state.query) return safe;
    var q = esc(state.query).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return safe.replace(new RegExp("(" + q + ")", "gi"), '<mark class="hrv-hl">$1</mark>');
  }

  function cardHtml(r, n) {
    var long = r.body.length > CLAMP && !state.expanded[r.id];
    var bodyText = long ? r.body.slice(0, CLAMP).replace(/\s+\S*$/, "") + "\u2026" : r.body;
    var media = r.media.length
      ? '<div class="hrv-card-media">' + r.media.map(function (m, mi) { return thumbHtml({ type: m.type, url: m.url, review: r }, r.id, mi); }).join("") + '</div>'
      : "";
    var isHelpful = !!helpful[r.id];
    return '<article class="hrv-card" data-card="' + r.id + '">' +
      '<div class="hrv-card-top"><div class="hrv-user">' +
        '<div class="hrv-avatar" style="background:' + avatarColor(r.name) + '">' + esc(initials(r.name)) + '</div>' +
        '<div class="hrv-user-meta"><span class="hrv-name">' + highlight(r.name) + '</span>' +
          (r.verified ? '<span class="hrv-verified">' + ICON_BADGE + 'Verified Buyer</span>' : "") +
        '</div></div>' +
        (r.dateStr ? '<span class="hrv-date">' + esc(r.dateStr) + '</span>' : "") +
      '</div>' +
      starsHtml(r.rating, 15) +
      (r.title ? '<h4 class="hrv-card-title">' + highlight(r.title) + '</h4>' : '<div style="height:8px"></div>') +
      '<p class="hrv-card-body">' + highlight(bodyText).replace(/\n/g, "<br>") +
        (r.body.length > CLAMP ? '<button type="button" class="hrv-more-link" data-expand="' + r.id + '">' + (long ? "Read more" : "Show less") + '</button>' : "") +
      '</p>' +
      media +
      '<div class="hrv-card-foot">' +
        '<span class="hrv-card-foot-note">' + (isHelpful ? "Thanks for your feedback" : "Was this helpful?") + '</span>' +
        '<button type="button" class="hrv-helpful' + (isHelpful ? " is-on" : "") + '" data-helpful="' + r.id + '" aria-pressed="' + isHelpful + '">' + ICON_THUMB + 'Helpful</button>' +
      '</div>' +
    '</article>';
  }

  function renderGrid() {
    renderChips();
    var list = filtered();
    var page = list.slice(0, state.visible);
    var grid = mount.querySelector("[data-grid]");
    var result = mount.querySelector("[data-result]");
    var more = mount.querySelector("[data-more]");

    if (!page.length) {
      grid.innerHTML = '<div class="hrv-empty">No reviews match your filters.<br><button type="button" class="hrv-btn hrv-btn--ghost" data-chip="all">Clear filters</button></div>';
    } else {
      grid.innerHTML = page.map(function (r, i) { return cardHtml(r, i); }).join("");
    }
    grid.classList.remove("is-swap"); void grid.offsetWidth; grid.classList.add("is-swap");
    revealCards();

    var anyFilter = state.star !== null || state.media || state.verified || state.query;
    result.textContent = anyFilter ? list.length + " of " + reviews.length + " reviews match" : "";

    if (list.length > state.visible) {
      var shown = page.length;
      more.innerHTML =
        '<div class="hrv-progress"><i style="width:' + Math.round((shown / list.length) * 100) + '%"></i></div>' +
        '<span class="hrv-progress-text">Showing ' + shown + ' of ' + list.length + ' reviews</span>' +
        '<button type="button" class="hrv-btn" data-loadmore>Show more reviews</button>';
    } else {
      more.innerHTML = list.length > PER_PAGE ? '<span class="hrv-progress-text">You\'ve seen all ' + list.length + ' reviews</span>' : "";
    }
  }

  /* ---------- Lightbox ---------- */
  function buildLightbox() {
    lb = document.createElement("div");
    lb.className = "hrv-lb hrv";
    lb.setAttribute("role", "dialog");
    lb.setAttribute("aria-modal", "true");
    lb.setAttribute("aria-label", "Customer media");
    lb.innerHTML =
      '<span class="hrv-lb-counter" data-lb-counter></span>' +
      '<button type="button" class="hrv-lb-btn hrv-lb-close" data-lb="close" aria-label="Close">' + ICON_X + '</button>' +
      '<button type="button" class="hrv-lb-btn hrv-lb-prev" data-lb="prev" aria-label="Previous">' + ICON_L + '</button>' +
      '<button type="button" class="hrv-lb-btn hrv-lb-next" data-lb="next" aria-label="Next">' + ICON_R + '</button>' +
      '<div class="hrv-lb-inner"><div class="hrv-lb-media" data-lb-media></div><div class="hrv-lb-side" data-lb-side></div></div>';
    document.body.appendChild(lb);
    applyColors(lb);

    lb.addEventListener("click", function (e) {
      var b = e.target.closest("[data-lb]");
      if (b) { var a = b.getAttribute("data-lb"); if (a === "close") closeLB(); else stepLB(a === "next" ? 1 : -1); return; }
      if (e.target === lb) closeLB();
    });
    document.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("is-open")) return;
      if (e.key === "Escape") closeLB();
      else if (e.key === "ArrowRight") stepLB(1);
      else if (e.key === "ArrowLeft") stepLB(-1);
    });
    var x0 = null;
    lb.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) stepLB(dx < 0 ? 1 : -1);
      x0 = null;
    });
  }

  function openLB(items, index) {
    if (!lb) buildLightbox();
    lbItems = items; lbIndex = index;
    showLB();
    lb.classList.add("is-open");
    document.documentElement.classList.add("hrv-lock");
    lb.querySelector(".hrv-lb-close").focus({ preventScroll: true });
  }
  function closeLB() {
    lb.classList.remove("is-open");
    document.documentElement.classList.remove("hrv-lock");
    var v = lb.querySelector("video"); if (v) v.pause();
  }
  function stepLB(d) {
    if (lbItems.length < 2) return;
    lbIndex = (lbIndex + d + lbItems.length) % lbItems.length;
    showLB();
  }
  function showLB() {
    var m = lbItems[lbIndex], r = m.review;
    lb.querySelector("[data-lb-media]").innerHTML = m.type === "img"
      ? '<img src="' + esc(m.url) + '" alt="Photo from ' + esc(r.name) + '">'
      : '<video src="' + esc(m.url) + '" controls autoplay playsinline></video>';
    lb.querySelector("[data-lb-side]").innerHTML =
      '<div class="hrv-user" style="margin-bottom:12px"><div class="hrv-avatar" style="background:' + avatarColor(r.name) + '">' + esc(initials(r.name)) + '</div>' +
      '<div class="hrv-user-meta"><span class="hrv-name">' + esc(r.name) + '</span>' +
      (r.verified ? '<span class="hrv-verified">' + ICON_BADGE + 'Verified Buyer</span>' : "") + '</div></div>' +
      starsHtml(r.rating, 15) +
      (r.dateStr ? '<div class="hrv-date" style="margin-top:6px">' + esc(r.dateStr) + '</div>' : "") +
      (r.title ? '<h4 class="hrv-card-title">' + esc(r.title) + '</h4>' : "") +
      '<p class="hrv-card-body">' + esc(r.body).replace(/\n/g, "<br>") + '</p>';
    var multi = lbItems.length > 1;
    lb.querySelector("[data-lb-counter]").textContent = multi ? (lbIndex + 1) + " / " + lbItems.length : "";
    lb.querySelector(".hrv-lb-prev").style.display = multi ? "" : "none";
    lb.querySelector(".hrv-lb-next").style.display = multi ? "" : "none";
  }

  /* ---------- Events (one delegated listener) ---------- */
  function bindEvents() {
    mount.addEventListener("click", function (e) {
      var t;
      if ((t = e.target.closest("[data-star]"))) {
        var s = parseInt(t.getAttribute("data-star"), 10);
        state.star = state.star === s ? null : s; state.visible = PER_PAGE; renderGrid();
        var g = mount.querySelector(".hrv-toolbar");
        if (g && g.getBoundingClientRect().top > window.innerHeight) g.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if ((t = e.target.closest("[data-chip]"))) {
        var c = t.getAttribute("data-chip");
        if (c === "all") {
          state.star = null; state.media = false; state.verified = false; state.query = "";
          var inp = mount.querySelector("[data-search]"); if (inp) inp.value = "";
        } else if (c === "media") state.media = !state.media;
        else if (c === "verified") state.verified = !state.verified;
        else if (c === "star") state.star = null;
        state.visible = PER_PAGE; renderGrid();
        var tb = mount.querySelector(".hrv-toolbar");
        if (tb && tb.getBoundingClientRect().top < 0) tb.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if ((t = e.target.closest("[data-loadmore]"))) {
        state.visible += PER_PAGE; renderGrid();
      } else if ((t = e.target.closest("[data-expand]"))) {
        var id = t.getAttribute("data-expand");
        state.expanded[id] = !state.expanded[id];
        var card = t.closest(".hrv-card"), rv0 = reviews.filter(function (x) { return x.id === id; })[0];
        if (card && rv0) {
          var tmp = document.createElement("div");
          tmp.innerHTML = cardHtml(rv0, 0);
          var fresh = tmp.firstChild;
          fresh.classList.add("is-in", "is-static");
          card.parentNode.replaceChild(fresh, card);
        }
      } else if ((t = e.target.closest("[data-helpful]"))) {
        var hid = t.getAttribute("data-helpful");
        if (helpful[hid]) delete helpful[hid]; else helpful[hid] = 1;
        saveHelpful();
        var on = !!helpful[hid];
        t.classList.toggle("is-on", on);
        t.setAttribute("aria-pressed", on ? "true" : "false");
        var note = t.parentNode.querySelector(".hrv-card-foot-note");
        if (note) note.textContent = on ? "Thanks for your feedback" : "Was this helpful?";
        t.classList.remove("is-pop"); void t.offsetWidth; if (on) t.classList.add("is-pop");
      } else if ((t = e.target.closest("[data-open]"))) {
        var scope = t.getAttribute("data-open"), i = parseInt(t.getAttribute("data-i"), 10);
        if (scope === "all") openLB(allMedia, i);
        else {
          var rv = reviews.filter(function (x) { return x.id === scope; })[0];
          if (rv) openLB(rv.media.map(function (m) { return { type: m.type, url: m.url, review: rv }; }), i);
        }
      }
    });
    mount.addEventListener("change", function (e) {
      if (e.target.matches("[data-sort]")) { state.sort = e.target.value; state.visible = PER_PAGE; renderGrid(); }
    });
    mount.addEventListener("input", function (e) {
      if (!e.target.matches("[data-search]")) return;
      clearTimeout(searchTimer);
      var val = e.target.value;
      searchTimer = setTimeout(function () { state.query = val.trim().toLowerCase(); state.visible = PER_PAGE; renderGrid(); }, 180);
    });
  }

  function applyColors(el) {
    if (S.ACCENT_COLOR) el.style.setProperty("--hrv-accent", S.ACCENT_COLOR);
    if (S.STAR_COLOR) el.style.setProperty("--hrv-star", S.STAR_COLOR);
    if (S.VERIFIED_COLOR) el.style.setProperty("--hrv-green", S.VERIFIED_COLOR);
    if (S.AVATAR_TEXT) el.style.setProperty("--hrv-avatar-text", S.AVATAR_TEXT);
  }

  function showMessage(html, isError) {
    mount.innerHTML = '<div class="hrv-wrap"><div class="hrv-empty' + (isError ? " hrv-error" : "") + '">' + html + '</div></div>';
  }

  function headHtml() {
    return '<div class="hrv-head">' +
      (S.EYEBROW ? '<span class="hrv-eyebrow">' + esc(S.EYEBROW) + '</span>' : "") +
      '<h2 class="hrv-title">' + esc(S.TITLE || "Ratings & Reviews") + '</h2>' +
      (S.SUBTITLE ? '<p class="hrv-sub">' + esc(S.SUBTITLE) + '</p>' : "") +
      writeBtn("hrv-write") +
    '</div>';
  }

  function writeBtn(cls, label) {
    var u = safeUrl(S.REVIEW_URL);
    if (!u) return "";
    return '<a class="' + cls + '" href="' + esc(u) + '" target="_blank" rel="noopener">' + ICON_PEN + esc(label || "Write a review") + '</a>';
  }

  function showEmpty() {
    if (S.HIDE_EMPTY) return hideHost();
    mount.innerHTML = '<div class="hrv-wrap">' + headHtml().replace(writeBtn("hrv-write"), "") +
      '<div class="hrv-zero">' +
        '<div class="hrv-zero-stars" aria-hidden="true">' + ICON_STAR + ICON_STAR + ICON_STAR + ICON_STAR + ICON_STAR + '</div>' +
        '<h3 class="hrv-zero-title">' + esc(S.EMPTY_TITLE || "No customer reviews yet") + '</h3>' +
        (S.EMPTY_TEXT ? '<p class="hrv-zero-text">' + esc(S.EMPTY_TEXT) + '</p>' : "") +
        writeBtn("hrv-btn hrv-zero-btn", "Write the first review") +
      '</div></div>';
  }

  /* Reveal cards as they scroll into view */
  var cardIO = null;
  function revealCards() {
    var cards = mount.querySelectorAll(".hrv-card:not(.is-in)");
    if (!("IntersectionObserver" in window)) { cards.forEach(function (c) { c.classList.add("is-in"); }); return; }
    if (!cardIO) {
      cardIO = new IntersectionObserver(function (entries) {
        var k = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.style.setProperty("--d", (k++ * 70) + "ms");
          en.target.classList.add("is-in");
          cardIO.unobserve(en.target);
        });
      }, { rootMargin: "0px 0px -8% 0px" });
    }
    cards.forEach(function (c) { cardIO.observe(c); });
  }

  /* Drag to scroll the photo strip with a mouse */
  function dragScroll(row) {
    if (!row || !window.matchMedia("(pointer: fine)").matches) return;
    var down = false, x0 = 0, s0 = 0, moved = false;
    row.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse") return;
      down = true; moved = false; x0 = e.clientX; s0 = row.scrollLeft;
      row.classList.add("is-drag");
    });
    window.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      if (Math.abs(dx) > 4) moved = true;
      row.scrollLeft = s0 - dx;
    });
    window.addEventListener("pointerup", function () { down = false; row.classList.remove("is-drag"); });
    row.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  /* ---------- Share the rating with the product section ---------- */
  function publish() {
    var n = reviews.length, sum = 0;
    reviews.forEach(function (r) { sum += r.rating; });
    var detail = { avg: n ? sum / n : 0, count: n, star: S.STAR_COLOR || "" };
    window.__pmrSummary = detail;
    try { document.dispatchEvent(new CustomEvent("pmr:summary", { detail: detail })); } catch (e) {}
  }

  function hideHost() {
    var host = mount.closest("[data-pmr]");
    if (host) host.hidden = true;
  }

  /* ---------- Init ---------- */
  function init() {
    mount = mountEl;
    if (!mount || mount.getAttribute("data-ready")) return;
    mount.setAttribute("data-ready", "1");
    applyColors(mount);

    if (!S.CSV_URL) {
      publish();
      return showEmpty();
    }

    fetch(S.CSV_URL)
      .then(function (res) { if (!res.ok) throw new Error("HTTP " + res.status); return res.text(); })
      .then(function (text) {
        var head = text.trim().slice(0, 200).toLowerCase();
        if (head.indexOf("<!doctype") === 0 || head.indexOf("<html") !== -1) {
          console.warn("[Reviews] The CSV link opens a web page, not a CSV file.");
          publish();
          return showEmpty();
        }
        reviews = buildReviews(parseCSV(text));
        publish();
        if (!reviews.length) return showEmpty();
        renderShell();
        renderGrid();
        bindEvents();
      })
      .catch(function (err) {
        console.error("[Reviews] Could not load CSV:", err);
        publish();
        showEmpty();
      });
  }

  init();
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-hrv]").forEach(function (host) {
      if (host.__hrv) return;
      host.__hrv = true;
      var S = {};
      try { S = JSON.parse(host.querySelector("[data-hrv-settings]").textContent); } catch (e) {}
      HRV(host.querySelector("[data-hrv-mount]"), S);
    });
  }

  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
})();

  } catch(e) { console.error(e); }
})();
})();
